export class Interval {
  private baseline: number | undefined;
  private timer: ReturnType<typeof setTimeout> | undefined;

  private run(onDown: () => void, duration: number) {
    const end = Date.now();
    this.baseline! += duration;
    let nextTick = duration - (end - this.baseline!);
    if (nextTick < 0) {
      nextTick = 0;
    }
    this.timer = setTimeout(() => {
      this.run(onDown, duration);
    }, nextTick);
    onDown();
  }

  start(onDown: () => void, duration: number) {
    this.baseline = Date.now();
    this.timer = setTimeout(() => {
      this.run(onDown, duration);
    }, duration);
  }

  stop() {
    this.baseline = undefined;
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
